import { Helmet as ReactHelmet } from "react-helmet";

export const Helmet = (props: {
    noindex?: boolean;
    title?: string;
    desc?: string;
    isHome?: boolean;
    img?: string;
    canonical?: string;
}) => {
    return (
        <div className="application">
            <ReactHelmet
                link={
                    props.canonical
                        ? [{ rel: "canonical", href: props.canonical }]
                        : undefined
                }
            >
                {props.title && <title>{props.title}</title>}
                {props.desc && <meta name="description" content={props.desc} />}
                {props.noindex && <meta name="robots" content="noindex" />}
            </ReactHelmet>
        </div>
    );
};
export default Helmet;
